import { useApiQuery } from '../../shared/hooks';
import type { QueryParamsType } from '../../shared/types';

export const useGetAirlines = (params: QueryParamsType<'/v2/air/airlines-info'>) => {
  return useApiQuery('/v2/air/airlines-info', params);
};
